// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2yJD6","inner":"Form_inner__LPU1s","range":"Form_range__2Uq2-","name":"Form_name__cCX1Z","actions":"Form_actions__1HYYA"};